import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

/**
 * Copy-carrier-account-credentials calls against tracking-processor-service (Shipium-internal
 * admin endpoint). Reached through the scoped `/tracking-processor-proxy/api/v1/
 * carrierAccountCredentialCopy` gateway route — the browser sends only ids + overwrite; secrets
 * are read partner→credentials server-to-server. Server-gated by TRACKING_INTERNAL_ADMIN_AUTHORITY.
 */
export const credentialCopy = {
  copyToCredentialService: async ({
    partnerId,
    carrierAccountId,
    overwrite,
  }: {
    partnerId: string;
    carrierAccountId: string;
    overwrite: boolean;
  }) => {
    const { data } = await GatewayAxiosClient.post<{
      credentialId: string;
      source: string;
      action: string;
    }>('/tracking-processor-proxy/api/v1/carrierAccountCredentialCopy', {
      partnerId,
      carrierAccountId,
      overwrite,
    });
    return data;
  },
  credentialCopyExcludedCarrierIds: {
    queryKey: 'tracking-processor-service/credential-copy-excluded',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<{ excludedCarrierIds: string[] }>(
        '/tracking-processor-proxy/api/v1/carrierAccountCredentialCopy/excludedCarrierIds',
      );
      return data.excludedCarrierIds;
    },
  },
};
